﻿import React, { useState, useEffect } from 'react';
import { CalculatorSampleSelection } from '../models/Calculators/calculator-sample-selection';
import { UpdateCalculatorStandardsRequest } from '../models/Calculators/update-calculator-standards-request';
import { CrudFunctions } from '../utilities/crud-functions';
import { ModalMetadata } from '../models/modal-metadata';
import { EditType, ModalMessageType } from '../models/enums';
import GlobalDialog from './Modal/GlobalDialog';
import { CalculatorStandard } from '../models/Calculators/calculator-standard';
import StandardsSearch from './StandardsSearch';
import { StandardReference } from '../models/Standards/standard-reference';
import { DataTemplates } from '../templates/data-templates';

import DataGrid, {
    Column,
    Selection,
    Editing,
    Paging,
    Toolbar,
    HeaderFilter,
    FilterRow,
    Item as ToolBarItem,
    LoadPanel
} from 'devextreme-react/data-grid';

import { Button } from 'devextreme-react/button';
import Guid from 'devextreme/core/guid';
import { Popup as DialogPopup } from 'devextreme-react/popup';

let key = 1;

export interface Props {
    calculatorId: string;
    batchId: string;
    catalogNumber: string;
    batchName: string;
    onClose?: () => void;
}

export default function CalculatorStandards(props: Props) {
    const [sampleSelections, setSampleSelections] =
        useState<CalculatorSampleSelection[]>();

    const [selectedSampleSelection, setSelectedSampleSelection] =
        useState<CalculatorSampleSelection>();

    const [calculatorStandards, setCalculatorStandards] =
        useState<CalculatorStandard[]>();

    const [standardsSearchDialogVisible, setStandardsSearchDialogVisible] =
        useState<boolean>()

    const [globalDialogMetadata, setGlobalDialogMetadata] =
        useState<ModalMetadata>();

    const [globalDialogVisible, setGlobalDialogVisible] =
        useState<boolean>()

    useEffect(() => {
        getAllData();
    }, [props.calculatorId]);

    let showRefStandard1Column = false;
    let showRefStandard2Column = false;
    let showRefStandard3Column = false;
    let refStandard1ColumnHeader = "";
    let refStandard2ColumnHeader = "";
    let refStandard3ColumnHeader = "";

    if (calculatorStandards && calculatorStandards.length > 0) {
        refStandard1ColumnHeader = `${calculatorStandards[0].catalogNumber}\n${calculatorStandards[0].lotNumber}`;
        showRefStandard1Column = true;
    }

    if (calculatorStandards && calculatorStandards.length > 1) {
        refStandard2ColumnHeader = `${calculatorStandards[1].catalogNumber}\n${calculatorStandards[1].lotNumber}`;
        showRefStandard2Column = true;
    }

    if (calculatorStandards && calculatorStandards.length > 2) {
        refStandard3ColumnHeader = `${calculatorStandards[2].catalogNumber}\n${calculatorStandards[2].lotNumber}`;
        showRefStandard3Column = true;
    }

    return (
        <div>
            <div className="pw-comp-row pw-margin-top-05">
                <div className="title-bar-spacer" />
                <div className="save-toolbar pw-margin-right-05">

                    <Button id="addStandardButton" text="Add Standard" icon="plus" type="success"
                        className="pw-button"
                        hint="add standard"
                        height={'1.8rem'}
                        onClick={onAddStandardClick} />

                    <Button id="saveButton" text="Save" icon="save" type="success"
                        className="pw-button"
                        hint="save changes"
                        height={'1.8rem'}
                        onClick={onSaveClick} />

                    <Button id="closeButton" text="Close" icon="close" type="normal"
                        className="pw-button"
                        hint="close dialog"
                        height={'1.8rem'}
                        onClick={onCloseClick} />
                </div>
            </div>

            <div className="pw-comp-row">
                <div className="pw-form-unit lq-header-3">MS Samples</div>
            </div>

            <div className="pw-comp-row">
                <div className="pw-form-unit">
                    <div className="pw-form-unit-label">Catalog Number</div>
                    <div className="pw-readonly-label">{props.catalogNumber}</div>
                </div>

                <div className="pw-form-unit">
                    <div className="pw-form-unit-label">Batch Name</div>
                    <div className="pw-readonly-label">{props.batchName}</div>
                </div>
            </div>

            {calculatorStandards && calculatorStandards.length > 0 && calculatorStandards.map((standard) =>
                <div key={standard.calculatorStandardId}>
                    <div className="pw-comp-row">
                        <div className="pw-form-unit lq-header-3">{standard.catalogNumber} - {standard.lotNumber}</div>
                    </div>

                    <div className="pw-comp-row" key={standard.calculatorStandardId.toString()}>
                        <div className="pw-form-unit pw-comp-20">
                            <div className="pw-form-unit-label">Standards Manufacturer</div>
                            <div className="pw-readonly-label">{standard.standardManufacturer &&
                                standard.standardManufacturer.description ?
                                standard.standardManufacturer.description : 'NA'}</div>
                        </div>

                        <div className="pw-form-unit">
                            <div className="pw-form-unit-label">Standard Catalog#</div>
                            <div className="pw-readonly-label">{standard.catalogNumber ?
                                standard.catalogNumber : 'NA'}</div>
                        </div>

                        <div className="pw-form-unit">
                            <div className="pw-form-unit-label">Standard Lot#</div>
                            <div className="pw-readonly-label">{standard.lotNumber ?
                                standard.lotNumber : 'NA'}</div>
                        </div>

                        <div className="pw-form-unit">
                            <Button id={`deleteStandardButton-${standard.calculatorStandardId}`}
                                text="" icon="trash" type="normal"
                                className="pw-button pw-margin-top-1"
                                hint="delete standard"
                                height='1.6rem'
                                onClick={onDeleteStandardButtonClick} />
                        </div>

                    </div>
                </div>
            )}

            <div>
                <DataGrid
                    width="100%"
                    height="30rem"
                    keyExpr="sampleTypeId"
                    dataSource={sampleSelections ? sampleSelections : []}
                    onSelectionChanged={onSampleSelectionSelectionChanged}
                    onRowValidating={onSampleSelectionValidating}
                    rowAlternationEnabled={true}
                    wordWrapEnabled={true}
                    showRowLines={true}
                    showBorders={true} >

                    <HeaderFilter visible={true} />
                    <FilterRow visible={true} />
                    <LoadPanel enabled={false} />

                    <Selection mode='single' />
                    <Paging enabled={false} />

                    <Column width='2rem' cssClass="table-vertical-align"
                        cellRender={DataTemplates.EditMarkerCellRender} />

                    <Column dataField='sampleName' dataType="string"
                        allowEditing={false}
                        width='20rem' cssClass="table-vertical-align" />

                    <Column dataField='isMsStandard' dataType="boolean"
                        caption="MS Samples"
                        width='12rem' cssClass="table-vertical-align" />

                    {showRefStandard1Column &&
                        <Column dataField='isReferenceStandard1' dataType="boolean"
                            caption={refStandard1ColumnHeader}
                            width='12rem' cssClass="table-vertical-align" />
                    }

                    {showRefStandard2Column &&
                        <Column dataField='isReferenceStandard2' dataType="boolean"
                            caption={refStandard2ColumnHeader}
                            width='12rem' cssClass="table-vertical-align" />
                    }

                    {showRefStandard3Column &&
                        <Column dataField='isReferenceStandard3' dataType="boolean"
                            caption={refStandard3ColumnHeader}
                            width='12rem' cssClass="table-vertical-align" />
                    }

                    <Column />

                    <Editing mode="cell"
                        useIcons={true}
                        allowAdding={false}
                        allowUpdating={true}
                        allowDeleting={false} />

                    <Toolbar>
                        <ToolBarItem location='before'>
                            <div className="pw-datagrid-toolbar-template">
                                <div className="pw-datagrid-toobar-title">Samples</div>
                            </div>
                        </ToolBarItem>
                    </Toolbar>
                </DataGrid>
            </div>

            {standardsSearchDialogVisible &&
                <DialogPopup key={`ssd_${key}`}
                    width="80vw" height="80vh"
                    visible={standardsSearchDialogVisible}
                    onHiding={hideStandardsSearchDialog}
                    dragEnabled={true}
                    hideOnOutsideClick={false}
                    title="Standards Search">
                    <StandardsSearch
                        onImportSelection={onImportStandardsFromSearchDialog}
                        onCancel={hideStandardsSearchDialog} />
                </DialogPopup>
            }

            {globalDialogVisible &&
                <GlobalDialog metadata={globalDialogMetadata} />
            }

        </div >
    );

    async function onImportStandardsFromSearchDialog(item: StandardReference) {
        const matchingStandard = calculatorStandards.findIndex(s => s.standardId === item.standardId);

        //TODO -
        console.log("matchingStandard:");
        console.log(matchingStandard);

        let editedCalculatorStandards = [...calculatorStandards];

        let newStandard: CalculatorStandard = {
            calculatorStandardId: new Guid().toString(),
            standardManufacturerId: item.manufacturerId,
            standardManufacturer: {
                id: item.manufacturerId,
                name: item.manufacturerName,
                description: item.manufacturerFullName
            },
            catalogNumber: item.catalogNumber,
            lotNumber: item.productName,
            standardId: item.standardId,

            editType: EditType.Insert
        };

        editedCalculatorStandards.push(newStandard);

        setCalculatorStandards(editedCalculatorStandards);
        setStandardsSearchDialogVisible(false);
    }

    function onSampleSelectionSelectionChanged(e: any) {
        if (e.selectedRowsData && e.selectedRowsData.length > 0) {
            setSelectedSampleSelection(e.selectedRowsData[0]);
        }
    }

    function onSampleSelectionValidating(e: any) {
        e.newData.editType = EditType.Update;
    }

    function onDeleteStandardButtonClick(e: any) {
        console.log("onDeleteStandardButtonClick");
        console.log(e);

        if (e.element && e.element.id) {
            const calculatorStandardId = (e.element.id as string).replace("deleteStandardButton-", "");

            console.log("extracted calculatorStandardId:");
            console.log(calculatorStandardId);

            let selectedCalculatorStandard = calculatorStandards.find(s => s.calculatorStandardId === calculatorStandardId);
            let selectedCalculatorStandardIdx = calculatorStandards.findIndex(s => s.calculatorStandardId === calculatorStandardId);

            console.log("selectedCalculatorStandardId:");
            console.log(selectedCalculatorStandard);

            if (selectedCalculatorStandard) {
                console.log("calculatorStandards:");
                console.log(calculatorStandards);

                let editedStandards = [...calculatorStandards];
                editedStandards.splice(selectedCalculatorStandardIdx, 1);

                setCalculatorStandards(editedStandards);
            }
        }
    }

    function onAddStandardClick() {
        setStandardsSearchDialogVisible(true);
    }

    async function onSaveClick() {
        const request: UpdateCalculatorStandardsRequest = {
            calculatorId: props.calculatorId,
            standards: calculatorStandards,
            samples: sampleSelections
        };

        console.log("request:");
        console.log(request);

        await updateCalculatorStandards(request)
            .then((data) => {
                getCalculatorSampleTypes();

            })
            .catch((res) => {
                showMessage(res, ModalMessageType.Error, "Error Updating Calculator Standards");
            });        
    }

    function onCloseClick() {
        if (props.onClose)
            props.onClose();
    }

    async function getCalculatorStandards() {
        await CrudFunctions.getData(`calculator/calculatorstandards/${props.calculatorId}`)
            .then((data) => {
                setCalculatorStandards(data);
            })
            .catch((res) => {
                showMessage(res, ModalMessageType.Error, "Error Retrieving Current Agilent Raw Data");
            })
    }

    async function getCalculatorSampleTypes() {
        await CrudFunctions.getData(`calculator/sampletypes/${props.calculatorId}`)
            .then((data) => {
                setSampleSelections(data);
            })
            .catch((res) => {
                showMessage(res, ModalMessageType.Error, "Error Retrieving Current Agilent Raw Data");
            })
    }

    async function getStandardByStandardId(standardId: string) {
        return await CrudFunctions.getData(`standards/standardreferencebystandardid/${standardId}`)

    }

    async function updateCalculatorStandards(data: UpdateCalculatorStandardsRequest) {
        return await CrudFunctions.putData("calculator/calculatorstandards", data);
    }

    async function getAllData() {
        await Promise.all([
            getCalculatorStandards(),
            getCalculatorSampleTypes()
        ]);
    }

    function hideStandardsSearchDialog() {
        setStandardsSearchDialogVisible(false);
    }

    function showMessage(res: any, mode: ModalMessageType, title: string) {
        let mm: ModalMetadata = {
            error: res,
            mode: mode,
            title: title
        };

        setGlobalDialogMetadata(mm);
        setGlobalDialogVisible(true);
    }
}